/* eslint-disable dot-notation */
import React, { useContext } from 'react';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';

import {
  Ctx,
  Check,
  Text,
} from 'containers/Forms/Settings/components/CtxInputs';
import { salesTenders } from 'containers/Forms/Settings/views/Payment/components/tenders';

const SalesTenders = ({ prefix }) => {
  const { values } = useContext(Ctx);
  const { t } = useTranslation('settingsPayment');
  return (
    <Table>
      <thead>
        <tr>
          <th>{t(`common.type`)}</th>
          <th style={{ width: '150px' }}>{t(`common.limit`)}</th>
        </tr>
      </thead>
      <tbody>
        {salesTenders.map(({ transKey, configName }) => (
          <tr key={transKey}>
            <td style={{ verticalAlign: 'inherit' }}>
              <Check
                title={t(`${prefix}.tenders.${transKey}`)}
                name={`pos_allow_sale_${configName}`}
              />
            </td>
            <td colSpan={2}>
              <Text
                name={`pos_allow_sale_${configName}_limit`}
                disabled={!values[`pos_allow_sale_${configName}`]}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default SalesTenders;
